import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-[6%]">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-center md:text-left">&copy; {new Date().getFullYear()} Birimo Insurance. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-2 gap-y-2 text-sm">
            <a href="/ContactUS" className="hover:text-gray-300">Contact</a>
            <span>|</span>
            <a href="/AboutUS" className="hover:text-gray-300">About Us</a>
            <span>|</span>
            <a href="/Media" className="hover:text-gray-300">Media</a>
            <span>|</span>
            <a href="/Blog" className="hover:text-gray-300">Blog</a>
            <span>|</span>
            <a href="/privacy-policy" className="hover:text-gray-300">Privacy Policy</a>
            <span>|</span>
            <a href="/" className="hover:text-gray-300">Home</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
